import React from 'react'
import ReactDOM from 'react-dom'

import Dropin from './Dropin'
import getWidgetProps from './standalone'
import fetchCss from './standalone/fetchCss'

const uploadWidgetInit = async config => {
  await fetchCss()
  const { domId } = config
  const props = getWidgetProps(config)

  ReactDOM.render(<Dropin {...props} />, document.getElementById(domId))
}
;(function accessGlobals() {
  window.UploadWidget = window.UploadWidget || {}
  window.UploadWidget.q = window.UploadWidget.q || []

  const [config] = window.UploadWidget.q

  if (config) {
    uploadWidgetInit(config)
  } else {
    // We overwrite the Array.prototype.push method
    //  to enable triggering `uploadWidgetInit` when calling.
    //  Then we revert to initial prototypal definition, so we don't
    //  init multiple times.
    window.UploadWidget.q.push = _config => {
      window.UploadWidget.q.push = Array.prototype.push
      uploadWidgetInit(_config)
      window.UploadWidget.q.push(_config)
    }
  }
})()
